import { useField } from 'formik';
import React from 'react';

import styled from '@emotion/styled';

import { IInputField } from './interface';

export const TextInputField: React.FC<IInputField> = ({
  label,
  lpiSrc,
  rpiSrc,
  className,
  ...props
}) => {
  const [field, meta] = useField(props);

  return (
    <InputWrapper className={className}>
      <InputLabel htmlFor={props.name || props.id}>{label}</InputLabel>
      <InputContainer>
        <Input {...field} {...props} />
        {lpiSrc ? <LeftPlaceHolderCardIcon alt="icon" src={lpiSrc} /> : null}
        {rpiSrc ? <RightPlaceHolderCardIcon alt="icon" src={rpiSrc} /> : null}
      </InputContainer>
      {meta.touched && meta.error ? (
        <FieldErrorInfo>{meta.error}</FieldErrorInfo>
      ) : null}
    </InputWrapper>
  );
};

export const TextAreaInputField: React.FC<IInputField> = ({
  label,
  lpiSrc,
  rpiSrc,
  className,
  ...props
}) => {
  const [field, meta] = useField(props);

  return (
    <InputWrapper className={className}>
      <InputLabel htmlFor={props.name || props.id}>{label}</InputLabel>
      <InputContainer>
        <TextArea {...field} {...props} rows={6} />
        {lpiSrc ? <LeftPlaceHolderCardIcon alt="icon" src={lpiSrc} /> : null}
        {rpiSrc ? <RightPlaceHolderCardIcon alt="icon" src={rpiSrc} /> : null}
      </InputContainer>
      {meta.touched && meta.error ? (
        <FieldErrorInfo>{meta.error}</FieldErrorInfo>
      ) : null}
    </InputWrapper>
  );
};

export const FieldErrorInfo = styled.div`
  font-size: 0.8rem;
  color: red;
  /* border: 2px solid red;
  height: 1.4rem; */
`;

export const InputWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.3rem;

  &.spanTwo {
    grid-column: span 2;
  }
`;

export const InputLabel = styled.label`
  font-weight: 400;
  font-size: 1rem;
  color: ${({ theme }) => theme.palette.tertiaryText};
`;

interface IInput {
  textAlign?: string;
  lpiSrc?: string;
  rpiSrc?: boolean;
}

export const Input = styled.input<IInput>`
  border: 1px solid #bdbdbd;
  border-radius: 4px;
  padding: 1.25rem 1rem;
  text-align: ${({ textAlign }) => (textAlign ? textAlign : 'left')};
  font-weight: 500;
  color: ${({ theme }) => theme.palette.text6};
  font-size: 1rem;
  line-height: 100%;
  height: 3.6rem;
  cursor: text;

  &:focus {
    outline: none;
    border-color: ${({ theme }) => theme.palette.brandHover};
  }
  &:hover {
    cursor: text;
  }

  &::placeholder {
    color: #dad8d8;
    opacity: 1;
  }
`;

const TextArea = styled.textarea<IInput>`
  border: 1px solid #bdbdbd;
  border-radius: 4px;
  padding: 1.25rem 1rem;
  text-align: ${({ textAlign }) => (textAlign ? textAlign : 'left')};
  font-weight: 500;
  color: ${({ theme }) => theme.palette.text6};
  font-size: 1rem;
  line-height: 100%;
  resize: none;
  cursor: text;

  /* appearance: none; */

  &:focus {
    outline: none;
    border-color: ${({ theme }) => theme.palette.brandHover};
  }
  &:hover {
    cursor: text;
  }

  &::placeholder {
    color: #dad8d8;
    opacity: 1;
  }
`;

export const Select = styled.select`
  border: 1px solid ${({ theme }) => theme.palette.brandHover};
  border-radius: 4px;
  padding: 0rem 1rem 0rem 1rem;
  font-weight: 400;
  font-size: 1rem;
  height: 48px;
  color: ${({ theme }) => theme.palette.brandHover};

  appearance: none;

  &:focus {
    outline: none;
    border-color: ${({ theme }) => theme.palette.brandHover};
  }
  &:hover {
    cursor: pointer;
  }

  &:has(option:checked:disabled) {
    color: #dad8d8;
  }
`;

export const InputContainer = styled.div`
  display: grid;
  height: fit-content;

  & > * {
    grid-column: 1;
    grid-row: 1;
  }
  &:hover {
    cursor: pointer;
  }
`;

export const LeftPlaceHolderCardIcon = styled.img`
  height: 1.5rem;
  display: grid;
  margin-left: 0.8rem;
  margin-top: 0.8rem;
`;

export const RightPlaceHolderCardIcon = styled.img`
  height: 1.5rem;
  display: grid;
  margin-right: 1rem;
  margin-left: auto;
  margin-top: 0.8rem;
`;

export const SelectDropDownIcon = styled.div`
  height: 1.5rem;
  display: grid;
  margin-right: 1rem;
  margin-left: auto;
  margin-top: 0.8rem;
`;
